import { render, staticRenderFns } from "./IngestionStats.vue?vue&type=template&id=2407b282&"
import script from "./IngestionStats.vue?vue&type=script&lang=js&"
export * from "./IngestionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports